import PropTypes from "prop-types";
import styles from "./CustomSwitch.module.css";

const CustomSwitch = ({checked, onChange, disabled = false, size = "default"}) => {
  const handleClick = () => {
    if (!disabled && onChange) {
      onChange(!checked);
    }
  };

  const switchClass = [
    styles.customSwitch,
    checked ? styles.checked : "",
    disabled ? styles.disabled : "",
    styles[size],
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div
      className={switchClass}
      onClick={handleClick}
      role="switch"
      aria-checked={checked}
      tabIndex={disabled ? -1 : 0}
      onKeyDown={e => {
        if ((e.key === "Enter" || e.key === " ") && !disabled) {
          e.preventDefault();
          handleClick();
        }
      }}
    >
      <div className={styles.switchHandle} />
    </div>
  );
};

CustomSwitch.propTypes = {
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  size: PropTypes.oneOf(["small", "default"]),
};

export default CustomSwitch;
